import React from "react";
import { useTranslation } from "react-i18next";
import TopNavigation from "@amzn/awsui-components-react/polaris/top-navigation";
import { useAppSelector } from "app/store";
import { i18nStrings, profileActions } from "./config";
import styles from "./style.module.scss";
import logo from "./logo.svg";
import { useDomain } from "../../utils/stage-utils";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import { Badge } from "@amzn/awsui-components-react";
import { useTaxType } from "../../hooks/useTaxType";

const Header: React.FC = () => {
  const { fullName, email, alias } = useAppSelector((state) => state.auth.user);
  const { t } = useTranslation();
  const domain = useDomain();
  const taxType = useTaxType();

  const appTitle = taxType === "PST" ? "PST Canada" : t("app_name");

  return (
    <TopNavigation
      id="header"
      className={styles.header}
      i18nStrings={i18nStrings}
      identity={{
        href: "#",
        title: (
          <SpaceBetween
            size={"s"}
            direction={"horizontal"}
            alignItems={"center"}
          >
            {appTitle}
            {<Badge color="blue">{domain.toString().toUpperCase()}</Badge>}
          </SpaceBetween>
        ) as unknown as string,
        logo: { src: logo, alt: appTitle },
      }}
      utilities={[
        {
          type: "menu-dropdown",
          text: fullName + " (" + alias + ")",
          description: email,
          iconName: "user-profile",
          items: profileActions,
        },
      ]}
    />
  );
};

export default Header;
